export const myBusinessListStyles = {
  // business card
  businessListCard: {
    display: "flex",
    flexDirection: "row",
    gap: "10px",
    marginVertical: "10px",
    cursor: "pointer",
  },
  businessListContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  businessListCardText: {
    fontSize: "19px",
    fontWeight: "600",
    color: "#000",
    borderBottom: "0.5px solid #8D8D8D",
    flex: 3,
    paddingBottom: "10px",
  },
  businessListDelete: {
    fontSize: 19,
    
    flex: 1,
    paddingBottom: 10,
  },

  //   business list details
  mainHeading: {
    fontSize: "32px",
    fontWeight: "700",
    color: "#000",
  },
  subHeading: {
    fontSize: "17px",
    fontWeight: "400",
    color: "#000",
  },
  shareContainer: {
    display: "flex",
  },
  shareText: {
    fontSize: "11px",
    fontWeight: "400",
    color: "#000",
  },

  iconRow: {
    display: "flex",
    flexDirection: "row",
  },
  iconWrapper: {
    width: 60,
    height: 60,
    margin: "10px",
    borderRadius: "30px",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    cursor: "pointer",
  },
  iconText: {
    fontSize: "11px",
    fontWeight: "500",
    color: "#000",
  },

  selectedBusinessContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    marginBottom: "10px",
    marginTop: "10px",
  },

  inputLabel: {
    fontSize: "24px",
    fontWeight: "600",
    color: "#000",
  },

  // selected business:
  qrDetailsContainer: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    justifyContent: "flex-start",
    gap: "50px",
    marginTop: 5,
  },
  qrContainer: {
    display: "flex",
    justifyContent: { xs: "center", sm: "flex-end" },
  },
  qrDetails: {
    display: "flex",
    flexDirection: "column",
    justifyContent: { xs: "center", sm: "flex-start" },
    alignItems: { xs: "center", sm: "flex-start" },
    textAlign: { xs: "center", sm: "flex-start" },
    gap: 2,
  },
  editButton: {
    color: "black",
    border: "1px solid black",
    "&:hover": {
      backgroundColor: "transparent",
      borderColor: "black",
    },
    width: "fit-content",
    paddingX: "50px",
  },
};
